export default "__VITE_ASSET__Aku_U9rC__"